export enum AuthApiRoutesEnum {
  LOGIN = 'login',
  TWO_FA_CHECK = '2fa',
  REGISTRATION = 'registration',
  FORGOT_PASSWORD = 'password/forgot',
  RESET_PASSWORD = 'password/reset',
  EXPIRED_PASSWORD = 'password/expired',
  USERS = 'users',
  ENABLED = 'enabled',
  HEALTH_CENTRES = 'health-centres',
  COUNTRIES = 'countries',
}
